import { Container, MButton, ArrowRight, MarketingPage } from "./ui";

export function NotFound() {
  return (
    <MarketingPage
      seo={{
        title: "Page not found — WonderfulDoctor",
        description: "The page you were looking for doesn't exist. Head back to WonderfulDoctor.",
        path: "/404",
        noindex: true,
      }}
    >
      <section className="relative overflow-hidden">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-96"
          style={{ background: "radial-gradient(60% 60% at 50% 0%, rgba(244,201,155,0.5) 0%, rgba(244,201,155,0) 70%)" }}
        />
        <Container className="relative flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
          <div className="font-display text-8xl italic text-warm-accent">404</div>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-warm-ink sm:text-4xl">
            This page wandered off.
          </h1>
          <p className="mt-4 max-w-md text-warm-muted">
            The link may be old or the page may have moved. Let's get you back on track.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <MButton to="/" className="px-6 py-3 text-base">
              Back home <ArrowRight />
            </MButton>
            <MButton to="/platform" variant="outline" className="px-6 py-3 text-base">
              Explore the platform
            </MButton>
          </div>
        </Container>
      </section>
    </MarketingPage>
  );
}
